import type { MagicJumpItem } from '@/api/types/magic-jump';
import type { NavBadge, NavConfig, NavResourceSlot, NavThirdLevelItem } from '@/api/types/nav';

// 这里是 app 的配置结构
// Map<String, dynamic> mapTemp = {
//   "list": [
//     {
//       'nav_title': '一级标题',
//       'title_color': '#00695C', // 一级标题颜色
//       'jump_target': {
//         'jump_type': 1,
//         'Jump_target': 6021,
//         'product_group': <String, dynamic>{
//           'id': 6021,
//           'name': 'Natural Colored',
//         },
//       },

//       /// 一级标题跳转配置 可以为null
//       'badge': <String, dynamic>{
//         'badge_type': 'text', // 角标类型
//         'text': 'A5', // 角标文案
//         'text_color': '#FFFFFF', // 角标文字颜色
//         'fill_color': '#00897B', // 角标背景颜色
//       }, //一级标题角标配置 可以为null

//       'two_level': {
//         'resource_slots_layout': '1', // 资源位布局 1 是单行  2 是双行
//         'resource_slots': <Map<String, dynamic>>[], // 资源位列表

//         'list': <Map<String, dynamic>>[
//           {
//             'nav_title': '二级标题',

//             ///不能为null
//             'title_color': '#00695C', // 二级标题颜色
//             'jump_target': {
//               'jump_type': 1,
//               'Jump_target': 6021,
//               'product_group': <String, dynamic>{
//                 'id': 6021,
//                 'name': 'Natural Colored',
//               },
//             },

//             /// 二级标题跳转配置 可以为null
//             'badge': <String, dynamic>{
//               'badge_type': 'text', // 角标类型
//               'text': 'A5', // 角标文案
//               'text_color': '#FFFFFF', // 角标文字颜色
//               'fill_color': '#00897B', // 角标背景颜色
//             },

//             /// 二级标题角标配置 可以为null
//             'three_level': {
//               'resource_slots_layout': '2', // 资源位布局 1 是单行  2 是双行
//               'resource_slots': <Map<String, dynamic>>[
//                 {
//                   'image_url':
//                       'https://picsum.photos/seed/categoryMock0/600/400',
//                   'title': '三级资源位文案',

//                   ///资源位文案
//                   'title_color': '#00695C',

//                   ///资源位文案颜色
//                   'jump_target': {
//                     'jump_type': 1,
//                     'Jump_target': 6021,
//                     'product_group': <String, dynamic>{
//                       'id': 6021,
//                       'name': 'Natural Colored',
//                     },
//                   },

//                   ///资源位跳转配置 可以为null
//                 }
//               ], // 资源位列表
//               'list': <Map<String, dynamic>>[
//                 {
//                   'nav_title': '三级标题',

//                   /// 3级标题 不能为null
//                   'title_color': '#00695C',

//                   ///三级标题颜色
//                   'jump_target': {
//                     'jump_type': 1,
//                     'Jump_target': 6021,
//                     'product_group': <String, dynamic>{
//                       'id': 6021,
//                       'name': 'Natural Colored',
//                     },
//                   },

//                   ///3级数据跳转配置 可以为null
//                   'badge': <String, dynamic>{
//                     'badge_type': 'text',
//                     'text': 'A5',
//                     'text_color': '#FFFFFF',
//                     'fill_color': '#00897B',
//                   },

//                   ///3级数据角标配置 可以为null
//                 },
//               ],
//             },

//             ///三级数据
//           }
//         ],
//       },
//     }
//   ]
// }

export const EMPTY_JUMP_TARGET: MagicJumpItem = {
  jump_type: 0,
};

const badgeText = (
  text: string,
  options?: {
    fill_color?: string;
    text_color?: string;
  },
): NavBadge => ({
  badge_type: 'text',
  text,
  text_color: options?.text_color || '#6d4f10',
  fill_color: options?.fill_color || '#efe0a3',
});

const linkTo = (Jump_target: string): MagicJumpItem => ({
  jump_type: 4,
  Jump_target,
});

const resourceImageMap = {
  hero: 'https://vooglam-us-3-test.s3.us-west-2.amazonaws.com/json-value/46d45c7fa0d52af987471f1355250f08.jpg',
  card1: 'https://cdn.vooglam.com/json-value/930b1724729439ffda6ac2bf906d595e.png',
  card2: 'https://cdn.vooglam.com/json-value/05a0943726cd6cee385bbc148c2091da.png',
  card3: 'https://cdn.vooglam.com/json-value/636c219465390237d699e9121d059765.png',
  card4: 'https://cdn.vooglam.com/json-value/4d6c0239bd9c884ace2d2c7ca69cd7df.png',
  campaign1: 'https://cdn.vooglam.com/json-value/1a5d8f3070fa49bdb3f28ccca67c1f54.jpg?adaptive=1',
  campaign2: 'https://cdn.vooglam.com/json-value/212760d6a95a305095383375b4074669.jpg?adaptive=1',
};

const createResource = (
  sort: number,
  resource_image: string,
  title: string,
  jump_target: MagicJumpItem,
  description = '',
): NavResourceSlot => ({
  sort,
  resource_image,
  title,
  description,
  jump_target,
});

const createTextItem = (
  sort: number,
  nav_title: string,
  jump_target: MagicJumpItem,
  badge?: NavBadge | null,
): NavThirdLevelItem => ({
  sort,
  nav_title,
  jump_target,
  badge: badge || null,
});

const createImageItem = (
  sort: number,
  nav_title: string,
  third_level_image: string,
  jump_target: MagicJumpItem,
): NavThirdLevelItem => ({
  sort,
  nav_title,
  third_level_image,
  jump_target,
});

export const navData: NavConfig = {
  list: [
    {
      nav_title: 'Eyeglasses',
      jump_target: linkTo('/eyeglasses'),
      badge: badgeText('Promotion'),
      resource_slots_layout: '1',
      resource_slots: [
        createResource(
          1,
          resourceImageMap.hero,
          'Crafted Like a Weapon',
          linkTo('/collections/bloody-opium'),
        ),
        createResource(
          2,
          resourceImageMap.campaign1,
          'Transitions Edit',
          linkTo('/transitions-lenses'),
        ),
        // createResource(3, resourceImageMap.card3, 'Vision Tools: Hypothesis', linkTo('/collections')),
        // createResource(4, resourceImageMap.card4, 'Mona Collection (WIP)', linkTo('/collections')),
      ],
      list: [
        {
          nav_title: 'Shop',
          display_style: 'text',
          sort: 1,
          list: [
            createTextItem(1, 'All Eyeglasses', linkTo('/eyeglasses')),
            createTextItem(2, "Women's", linkTo('/eyeglasses/women')),
            createTextItem(3, "Men's", linkTo('/eyeglasses/men')),
            createTextItem(4, 'New Arrivals', linkTo('/new-arrivals')),
            createTextItem(5, 'Bestsellers', linkTo('/bestsellers')),
            createTextItem(6, 'Sale', linkTo('/sale')),
          ],
        },
        {
          nav_title: 'By Prescription',
          display_style: 'text',
          sort: 2,
          list: [
            createTextItem(1, 'Single Vision', linkTo('/single-vision-glasses')),
            createTextItem(2, 'Progressive', linkTo('/progressive-glasses')),
            createTextItem(3, 'Reading', linkTo('/reading-glasses')),
            createTextItem(4, 'Non-prescription', linkTo('/non-prescription-glasses')),
          ],
        },
        {
          nav_title: 'By Lens Type',
          display_style: 'text',
          badge: badgeText('Promotion'),
          sort: 3,
          list: [
            createTextItem(1, 'Transitions', linkTo('/transitions-lenses'), badgeText('Promotion')),
            createTextItem(2, 'Blue-light blocking', linkTo('/blue-light-blocking-glasses')),
            createTextItem(3, 'Photochromic', linkTo('/photochromic-glasses')),
            createTextItem(4, 'Driving', linkTo('/driving-glasses')),
            createTextItem(5, 'See all lens options', linkTo('/lens-guide')),
          ],
        },
        {
          nav_title: 'By Shape',
          display_style: 'text',
          sort: 4,
          list: [
            createTextItem(1, 'Rectangle', linkTo('/eyeglasses/rectangle')),
            createTextItem(2, 'Square', linkTo('/eyeglasses/square')),
            createTextItem(3, 'Cat eye', linkTo('/eyeglasses/cat-eye')),
            createTextItem(4, 'Geometric', linkTo('/eyeglasses/geometric')),
            createTextItem(5, 'Round', linkTo('/eyeglasses/round')),
            createTextItem(6, 'Aviator', linkTo('/eyeglasses/aviator')),
            createTextItem(7, 'Butterfly', linkTo('/eyeglasses/butterfly')),
            createTextItem(8, 'Oval', linkTo('/eyeglasses/oval')),
            createTextItem(9, 'Browline', linkTo('/eyeglasses/browline')),
          ],
        },
        {
          nav_title: 'By Color',
          display_style: 'text',
          sort: 5,
          list: [
            createTextItem(1, 'Black', linkTo('/eyeglasses/black')),
            createTextItem(2, 'Red', linkTo('/eyeglasses/red')),
            createTextItem(3, 'Two-tone', linkTo('/eyeglasses/two-tone')),
            createTextItem(4, 'Tortoise', linkTo('/eyeglasses/tortoise')),
            createTextItem(5, 'Multicolor', linkTo('/eyeglasses/multicolor')),
            createTextItem(6, 'Gold', linkTo('/eyeglasses/gold')),
            createTextItem(7, 'Purple', linkTo('/eyeglasses/purple')),
            createTextItem(8, 'Green', linkTo('/eyeglasses/green')),
            createTextItem(9, 'Pattern', linkTo('/eyeglasses/pattern')),
            createTextItem(10, 'Silver', linkTo('/eyeglasses/silver')),
            createTextItem(11, 'Gray', linkTo('/eyeglasses/gray')),
            createTextItem(12, 'Pink', linkTo('/eyeglasses/pink')),
          ],
        },
      ],
    },
    {
      nav_title: 'Sunglasses',
      jump_target: linkTo('/sunglasses'),
      resource_slots_layout: '1',
      resource_slots: [
        createResource(1, resourceImageMap.campaign1, 'Crafted Like a Weapon', linkTo('/sale')),
        createResource(2, resourceImageMap.card2, 'Summer Shapes', linkTo('/sunglasses')),
      ],
      list: [
        {
          nav_title: 'Shop',
          display_style: 'text',
          sort: 1,
          list: [
            createTextItem(1, 'All Sunglasses', linkTo('/sunglasses')),
            createTextItem(2, "Women's", linkTo('/sunglasses/women')),
            createTextItem(3, "Men's", linkTo('/sunglasses/men')),
            createTextItem(4, 'New Arrivals', linkTo('/new-arrivals')),
            createTextItem(5, 'Bestsellers', linkTo('/bestsellers')),
            createTextItem(6, 'Sale', linkTo('/sale')),
          ],
        },
        {
          nav_title: 'By Lens Type',
          display_style: 'text',
          sort: 2,
          list: [
            createTextItem(1, 'Non-prescription', linkTo('/sunglasses/non-prescription')),
            createTextItem(2, 'Prescription', linkTo('/sunglasses/prescription')),
            createTextItem(3, 'Fashion Tints', linkTo('/fashion-tint-glasses')),
            createTextItem(4, 'Polarized', linkTo('/polarized-glasses')),
            createTextItem(5, 'Clip-ons', linkTo('/clip-on-sunglasses')),
            createTextItem(6, 'See all lens options', linkTo('/lens-guide')),
          ],
        },
        {
          nav_title: 'By Shape',
          display_style: 'text',
          sort: 3,
          list: [
            createTextItem(1, 'Rectangle', linkTo('/sunglasses/rectangle')),
            createTextItem(2, 'Square', linkTo('/sunglasses/square')),
            createTextItem(3, 'Cat eye', linkTo('/sunglasses/cat-eye')),
            createTextItem(4, 'Geometric', linkTo('/sunglasses/geometric')),
            createTextItem(5, 'Round', linkTo('/sunglasses/round')),
            createTextItem(6, 'Aviator', linkTo('/sunglasses/aviator')),
            createTextItem(7, 'Butterfly', linkTo('/sunglasses/butterfly')),
            createTextItem(8, 'Oval', linkTo('/sunglasses/oval')),
            createTextItem(9, 'Browline', linkTo('/sunglasses/browline')),
          ],
        },
        {
          nav_title: 'By Color',
          display_style: 'text',
          sort: 4,
          list: [
            createTextItem(1, 'Black', linkTo('/sunglasses/black')),
            createTextItem(2, 'Red', linkTo('/sunglasses/red')),
            createTextItem(3, 'Two-tone', linkTo('/sunglasses/two-tone')),
            createTextItem(4, 'Tortoise', linkTo('/sunglasses/tortoise')),
            createTextItem(5, 'Multicolor', linkTo('/sunglasses/multicolor')),
            createTextItem(6, 'Gold', linkTo('/sunglasses/gold')),
            createTextItem(7, 'Purple', linkTo('/sunglasses/purple')),
            createTextItem(8, 'Green', linkTo('/sunglasses/green')),
            createTextItem(9, 'Pattern', linkTo('/sunglasses/pattern')),
            createTextItem(10, 'Silver', linkTo('/sunglasses/silver')),
            createTextItem(11, 'Gray', linkTo('/sunglasses/gray')),
            createTextItem(12, 'Pink', linkTo('/sunglasses/pink')),
          ],
        },
        {
          nav_title: 'Collection',
          display_style: 'text',
          sort: 5,
          list: [
            createTextItem(1, 'Collaborations', linkTo('/collections')),
            createTextItem(2, 'Featured', linkTo('/special-offers')),
            createTextItem(3, 'Vintage', linkTo('/collections/vintage')),
            createTextItem(4, 'Classic', linkTo('/collections/classic')),
            createTextItem(5, 'Bold', linkTo('/collections/bold')),
            createTextItem(6, 'Dark', linkTo('/collections/dark')),
          ],
        },
      ],
    },
    {
      nav_title: 'Collections',
      jump_target: linkTo('/collections'),
      resource_slots_layout: '2',
      resource_slots: [],
      list: [
        {
          nav_title: 'Style',
          display_style: 'text',
          sort: 1,
          list: [
            createTextItem(1, 'Vintage', linkTo('/collections/vintage')),
            createTextItem(2, 'Classic', linkTo('/collections/classic')),
            createTextItem(3, 'Bold', linkTo('/collections/bold')),
            createTextItem(4, 'Dark', linkTo('/collections/dark')),
            createTextItem(5, '2026 Spring', linkTo('/new-arrivals')),
          ],
        },
        {
          nav_title: 'Special Edition',
          display_style: 'text',
          sort: 2,
          list: [
            createTextItem(1, 'Bloody Opium', linkTo('/collections/bloody-opium')),
            createTextItem(2, 'Dancing Queen', linkTo('/collections/dancing-queen')),
          ],
        },
        {
          nav_title: 'Designer Collaborations',
          display_style: 'image',
          sort: 3,
          list: [
            createImageItem(
              1,
              'Vision Tools: Hypothesis',
              resourceImageMap.card2,
              linkTo('/collections'),
            ),
            createImageItem(
              2,
              'Mona Collection (WIP)',
              resourceImageMap.card3,
              linkTo('/collections'),
            ),
            createImageItem(
              3,
              'Vision Tools: Hypothesis',
              resourceImageMap.card4,
              linkTo('/collections'),
            ),
            createImageItem(
              4,
              'Mona Collection (WIP)',
              resourceImageMap.campaign2,
              linkTo('/collections'),
            ),
          ],
        },
      ],
    },
    {
      nav_title: 'Special Offers',
      nav_title_color: '#fe5000',
      jump_target: linkTo('/special-offers'),
      resource_slots_layout: '1',
      resource_slots: [
        createResource(1, resourceImageMap.campaign1, 'Crafted Like a Weapon', linkTo('/sale')),
        createResource(2, resourceImageMap.card4, 'Crafted Like a Weapon', linkTo('/sale')),
        createResource(3, resourceImageMap.card3, 'Crafted Like a Weapon', linkTo('/sale')),
        createResource(4, resourceImageMap.card2, 'Crafted Like a Weapon', linkTo('/sale')),
      ],
      list: [
        {
          nav_title: 'Special Offers',
          display_style: 'text',
          sort: 1,
          list: [
            createTextItem(1, "Valentine's Day", linkTo('/sale/valentines-day')),
            createTextItem(2, 'Sale', linkTo('/sale')),
          ],
        },
        {
          nav_title: 'Special Offers',
          display_style: 'text',
          sort: 2,
          list: [
            createTextItem(1, "Valentine's Day", linkTo('/sale/valentines-day')),
            createTextItem(2, 'Sale', linkTo('/sale')),
          ],
        },
      ],
    },
    {
      nav_title: 'Accessories',
      jump_target: linkTo('/accessories'),
      resource_slots_layout: '1',
      resource_slots: [
        createResource(1, resourceImageMap.hero, 'Spring Starts Here', linkTo('/accessories')),
      ],
      list: [
        {
          nav_title: 'Shop',
          display_style: 'text',
          sort: 1,
          list: [
            createTextItem(1, 'Cases', linkTo('/accessories/cases')),
            createTextItem(2, 'Chains', linkTo('/accessories/chains')),
            createTextItem(3, 'Cloths', linkTo('/accessories/cloths')),
            createTextItem(4, 'Care Kits', linkTo('/accessories/care-kit')),
          ],
        },
      ],
    },
    {
      nav_title: 'New Arrivals',
      jump_target: linkTo('/new-arrivals'),
      resource_slots_layout: '1',
      resource_slots: [],
      list: [],
    },
  ],
};
